// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YduY","questions":"styles_questions__195No","footer":"styles_footer__2lguJ"};